/**
 * Abstract Hypercube.js material.
 * @example
 * class MaterialExample extends Material {}
 */
class Material {

    /**
     * Stores the name.
     * @type {string}
     * @private
     */
    $name;

    /**
     * Stores the parameters.
     * @type {any}
     * @protected
     */
    $parameters;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type;

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Gets the parameters.
     * @type {any}
     * @public
     * @readonly
     */
    get parameters() {

        return this.$parameters;
    };

    /**
     * Gets the type.
     * @type {string}
     * @public
     * @readonly
     */
    get type() {

        return this.$type;
    };

    // @TODO : replace {any} for $parameters

    /**
     * Creates a new Hypercube.js material.
     * @param {string} [$name] The name of the material.
     * @param {any} [$parameters] The parameters of the material.
     */
    constructor($name = 'Material', $parameters = {}) {

        this.$name = $name;

        this.$parameters = structuredClone($parameters);
    }
}

export {

    Material
};

export default Material;
